import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { useCallback } from 'react';
import { Trans } from 'react-i18next';
import { useStore } from 'zustand';
import { useCustomTranslation } from '../../../../hooks';
import { GridFiltersProps } from '@nexelem/table';

type RemoveFilterModalProps = Pick<GridFiltersProps, 'store'> & {
  readonly id: string;
  readonly name: string;
};

const RemoveFilterModal = ({ name, id, store }: RemoveFilterModalProps) => {
  const { tWrapper } = useCustomTranslation('components.filters.removeModal');

  const saveGridSettings = useStore(store, (state) => state.saveSettings);
  const gridSettings = useStore(store, (state) => state.settings);

  const handleRemoveFilter = useCallback(() => {
    const newGridSettings = (gridSettings || []).filter((cachedFilter) => cachedFilter.id !== id);
    saveGridSettings(newGridSettings);
    closeRemoveFilterModal();
  }, [gridSettings, id, saveGridSettings]);

  return (
    <StaticModal onClose={closeRemoveFilterModal}>
      <StaticModal.Header withCloseButton>{tWrapper('header')}</StaticModal.Header>
      <StaticModal.Content className="flex flex-col gap-6">
        <span className="text-s18 text-text-primary">
          <Trans components={{ strong: <strong /> }}>{tWrapper('name', { name })}</Trans>
        </span>
        <div className="flex flex-col gap-y-2">
          <span className="text-s18 text-text-primary">{tWrapper('description')}</span>
        </div>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={handleRemoveFilter}>
          {tWrapper('remove')}
        </Button>
        <Button variant="contained" onClick={closeRemoveFilterModal}>
          {tWrapper('cancel')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openRemoveFilterModal, closeRemoveFilterModal } = createModal(RemoveFilterModal, {
  name: 'RemoveFilterModal',
});
